import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CancelGenerativeTaskMutationVariables = Types.Exact<{
  input: Types.CancelGenerativeTaskInput;
}>;


export type CancelGenerativeTaskMutation = { cancelGenerativeTask?: { success?: boolean | null } | null };


export const CancelGenerativeTaskDocument = /*#__PURE__*/ gql`
    mutation cancelGenerativeTask($input: CancelGenerativeTaskInput!) {
  cancelGenerativeTask(data: $input) {
    success
  }
}
    `;

export function useCancelGenerativeTaskMutation() {
  return Urql.useMutation<CancelGenerativeTaskMutation, CancelGenerativeTaskMutationVariables>(CancelGenerativeTaskDocument);
};